// 引入配置文件
const configs = require('../config/configs.js');

// 取得 Google Analytics Cookie
const gaCookie = configs.getCookie('_ga');

// 從 Cookie 取得 uuid，若無則為 0
const uuid = gaCookie ? gaCookie.match(/(\d+)\.(\d+)$/gi)[0] : 0;

// 設定預設 headers
const headers = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-Requested-With': uuid,
};

// 取商品集合資料
const getProducts = async (pids, type = 1) => {
  // 發送商品資訊請求
  const resultData = await fetch(`${configs.ecApiPath}product/v2/productinfo`, {
    method: 'POST',
    body: JSON.stringify({
      param: {
        productIdList: pids,
        type,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((res) => res.json())
    .then((res) => {
      const { resultCode, resultData } = res;
      // 若成功且有資料，處理圖片路徑
      return resultCode === 0 && resultData.length > 0
        ? resultData.map((v) => {
            const img = v.images && v.images.replace('-uat2', '');
            return Object.assign(v, { images: img, image_url: img });
          })
        : null;
    })
    .catch((err) => {
      console.error(err);
      return null;
    });

  // 將資料轉為以 productId 為 key 的物件
  return resultData && resultData.length > 0
    ? resultData.reduce((p, v) => {
        const idx = v.productId;
        return Object.assign(p, { [idx]: v });
      }, {})
    : null;
};

module.exports = {
  // 取得 T List
  getTList: async (postData) => {
    try {
      const res = await fetch(`${configs.aiApiPath}gettlist`, {
        method: 'POST',
        headers,
        body: JSON.stringify(postData),
      });
      const json = await res.json();
      // 回傳第一筆資料或 null
      return Array.isArray(json) && json.length > 0 ? json[0] : null;
    } catch (err) {
      console.error(err);
      return null;
    }
  },

  // 取得 A List，並可依 filterCategoryB 過濾
  getAList: async (filterCategoryB = null) => {
    // 預設過濾條件
    const kvFilters = { k: '0000000', v: ['', '', '', '', '', '', ''] };

    // 若有指定 filterCategoryB，調整過濾條件
    if (filterCategoryB) {
      kvFilters.k = '0010000';
      kvFilters.v[2] = filterCategoryB;
    }

    try {
      // 發送取得 A List 請求
      const adataRes = await fetch(`${configs.aiApiPath}getalist`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          target_value: uuid,
          q1_x: 0.5,
          supplier_y: 0,
          filter: kvFilters,
          list_num: 13,
          type: 3,
        }),
      });
      const adataJson = await adataRes.json();
      const adata = adataJson[0]?.pids;

      if (!adata) return [];

      // 取得商品詳細資料
      const pdata = await getProducts(adata.map((p) => p.pid));
      // 合併商品資料
      return adata.map((v) => {
        return Object.assign(v, pdata[v.pid]);
      });
    } catch (err) {
      console.error(err);
      return [];
    }
  },
};
